import { AUTH_COMPANY_SELECTOR_SEARCH_THRESHOLD } from 'common/constants/auth';

export const FILTER_COMPANY_NUMBER = AUTH_COMPANY_SELECTOR_SEARCH_THRESHOLD;
export const COMPANY_SELECTOR_SEARCH_LABEL = 'Search companies';
export const COMPANY_SELECTOR_LOADING_LABEL = 'Loading your companies.';
